import React from "react";
import surya from "../surya.jpeg";
import "./OwnerCard.css";
import { FaWhatsapp } from "react-icons/fa";

const OwnerCard = () => {
  return (
    <div className="owner-card">
      <div className="owner-image">
        <img src={surya} alt="Owner" />
      </div>

      <div className="owner-content">
        <h2>SURYA NARAYANA</h2>
        <h5>Meet the Owner</h5>
        <p>
          Real estate is more than transactions — it’s about people and their dreams.
          I take pride in understanding each client’s unique needs and guiding them
          every step of the way. My goal is simple: to make your property journey
          stress-free, transparent, and successful.
        </p>
        <p>Feel free to reach out directly — I’m always happy to help.</p>
        <a
          href="https://wa.me/919849109978" // Replace with your WhatsApp number
          target="_blank"
          rel="noopener noreferrer"
          className="whatsapp-float"
        >
          <FaWhatsapp className="whatsapp-icon" />
          <span className="whatsapp-text">Chat with us on WhatsApp</span>
        </a>
      </div>
    </div>
  );
};

export default OwnerCard;